import { createContext, PropsWithChildren } from "react";

export const NavigationCollapsedContext = createContext<boolean>(false);

export const NavigationCollapsedContextProvider = ({
  children,
  value,
}: PropsWithChildren<{
  value: boolean;
}>) => {
  return (
    <NavigationCollapsedContext.Provider value={value}>
      {children}
    </NavigationCollapsedContext.Provider>
  );
};
